import { Link } from "react-router-dom";
import { Camera, Users, TrendingUp, DollarSign, Zap, BarChart3, ArrowRight, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FEATURES = [
  { icon: Camera, t: "Creator Profile", d: "A beautiful public profile fans can discover, follow, and support." },
  { icon: Zap, t: "AutoPilot Mode", d: "Upload once. We publish, notify subscribers, and update analytics — automatically." },
  { icon: Users, t: "Fan Management", d: "See who's following, subscribing, and buying. Message them directly." },
  { icon: TrendingUp, t: "Discovery Engine", d: "Get matched to fans based on interests — no ads, no guessing." },
  { icon: DollarSign, t: "70% Earnings", d: "Keep 70% of every purchase, tip, and subscription. Simple, fair, transparent." },
  { icon: BarChart3, t: "Performance Analytics", d: "Track earnings, views, and growth in real time from your dashboard." },
];

export default function ForCreators() {
  return (
    <div className="pt-32 pb-20">
      <section className="max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <p className="overline text-brand mb-4">For Creators</p>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-tight">Build Your Brand.<br /><span className="text-brand">Get Paid.</span></h1>
          <p className="mt-5 text-white/65 text-lg max-w-2xl mx-auto">Fan Focus gives you the tools to grow and the audience to earn. You create — we handle the rest.</p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/signup?type=creator" className="bg-brand text-white px-8 py-3.5 rounded-lg font-semibold inline-flex items-center gap-2" data-testid="fc-join">Join as a Creator <ArrowRight size={15} /></Link>
            <Link to="/pricing" className="border border-white/25 text-white px-8 py-3.5 rounded-lg font-semibold hover:border-brand hover:text-brand transition-colors" data-testid="fc-plans">See Plans</Link>
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURES.map((f, i) => (
          <Reveal key={i} delay={(i%3)*0.06}>
            <div className="card p-7 h-full" data-testid={`fc-feat-${i}`}>
              <f.icon className="text-brand mb-4" size={28} strokeWidth={1.5} />
              <h3 className="text-white font-semibold text-lg">{f.t}</h3>
              <p className="text-white/60 text-sm mt-2 leading-relaxed">{f.d}</p>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-6 mt-20 text-center card p-10">
        <Reveal>
          <h2 className="font-display text-3xl md:text-4xl text-white">Fair, Transparent Split</h2>
          <p className="mt-3 text-white/65">You earn <span className="text-brand font-semibold">70%</span> of every purchase. Fan Focus keeps <span className="text-white font-semibold">30%</span> to run the platform, discovery, payments, and support.</p>
          <div className="mt-6 flex items-center justify-center gap-3 text-white/70">
            <Check className="text-brand" size={18} /> No hidden fees
            <Check className="text-brand" size={18} /> No lock-ins
            <Check className="text-brand" size={18} /> Cancel anytime
          </div>
        </Reveal>
      </section>
    </div>
  );
}
